import $ from 'jquery'
import lottie from 'lottie-web/build/player/lottie_light.min'
import initInputSpinner from './js/utils/init-input-spinner'
import BHubCalendar from './js/utils/bhub-calendar.js'
import airDatepickerLocales from './js/utils/air-datepicker-locales.js'

const i18n = bookingHub

// eslint-disable-next-line no-undef
class BhubElementorBookingFormHandler
  extends elementorModules.frontend.handlers.Base
{
  constructor(...args) {
    super(...args)

    this.lottie = null
    this.checkInDatepicker = null
    this.date = ''
    this.daterange = []
    this.requesting = false
    this.mainArgs = {}
  }
  getYmd(month, year) {
    const date = new Date()

    date.setFullYear(year, month, 1)

    const formattedYear = date.getFullYear()
    const formattedMonth = ('0' + (date.getMonth() + 1)).slice(-2)
    const formattedDay = '01'

    return formattedYear + '-' + formattedMonth + '-' + formattedDay
  }
  getDefaultSettings() {
    return {
      selectors: {
        lottieSearchAnimationSelector: '.bhub-l-search-animation',
        buttonSelector: '.bhub-button[type="submit"]',
        formSelector: '.bhub-sp-template-booking-form',
        inputSpinnerSelector: '.bhub-input-spinner__input',
        guestsToggleSelector: '.bhub-sp-template-booking-form__guest-toggle',
        roomCountToggleSelector:
          '.bhub-sp-template-booking-form__room-count-toggle',
        guestFieldSelector: '.bhub-sp-template-booking-form__guest-field',
        roomCountFieldSelector:
          '.bhub-sp-template-booking-form__room-count-field',
        totalHolderSelector: '.bhub-sp-template-booking-form__total-holder',
        checkInDatepickerSelector: '.bhub-sp-template-booking-form__check-in',
        checkOutDatepickerSelector: '.bhub-sp-template-booking-form__check-out',
        guestHolderSelector: '.bhub-sp-template-booking-form__guest-holder',
        adultCountHolderSelector:
          '.bhub-sp-template-booking-form__adult-count-holder',
        roomCountHolderSelector:
          '.bhub-sp-template-booking-form__room-count-holder',
        rateToggleSelector: '.bhub-sp-template-booking-form__rate-toggle',
        rateFieldSelector: '.bhub-sp-template-booking-form__rate-field',
        rateHolderSelector: '.bhub-sp-template-booking-form__rate-holder',
      },
    }
  }
  getDefaultElements() {
    const selectors = this.getSettings('selectors')
    return {
      $lottieSearchAnimationSelector: this.$element.find(
        selectors.lottieSearchAnimationSelector
      ),
      $buttonSelector: this.$element.find(selectors.buttonSelector),
      $formSelector: this.$element.find(selectors.formSelector),
      $daterangeSelector: this.$element.find(selectors.daterangeSelector),
      $inputSpinnerSelector: this.$element.find(selectors.inputSpinnerSelector),
      $guestsToggleSelector: this.$element.find(selectors.guestsToggleSelector),
      $roomCountToggleSelector: this.$element.find(
        selectors.roomCountToggleSelector
      ),
      $guestFieldSelector: this.$element.find(selectors.guestFieldSelector),
      $roomCountFieldSelector: this.$element.find(
        selectors.roomCountFieldSelector
      ),
      $adultSelector: this.$element.find('input[name="adult"]'),
      $childrenSelector: this.$element.find('input[name="child"]'),
      $extrasSelector: this.$element.find('input[name="extra[]"]'),
      $roomCountSelector: this.$element.find('input[name="room_count"]'),
      $totalHolderSelector: this.$element.find(selectors.totalHolderSelector),
      $checkInDatepickerSelector: this.$element.find('input[name="check_in"]'),
      $checkOutDatepickerSelector: this.$element.find(
        'input[name="check_out"]'
      ),
      $guestHolderSelector: this.$element.find(selectors.guestHolderSelector),
      $adultCountHolderSelector: this.$element.find(
        selectors.adultCountHolderSelector
      ),
      $roomCountHolderSelector: this.$element.find(
        selectors.roomCountHolderSelector
      ),
      $rateToggleSelector: this.$element.find(selectors.rateToggleSelector),
      $rateFieldSelector: this.$element.find(selectors.rateFieldSelector),
      $rateHolderSelector: this.$element.find(selectors.rateHolderSelector),
      $rateSelector: this.$element.find('input[name="rate"]'),
    }
  }
  bindEvents() {
    if (this.elements.$lottieSearchAnimationSelector.length) {
      this.loadLottieSearchAnimation()
    }
    if (this.elements.$inputSpinnerSelector.length) {
      this.initInputSpinner()
    }
    this.initDynamicTotal()
    this.loadCalendars()
    this.elements.$formSelector.on('submit', this.submitEvent.bind(this))
    this.elements.$guestsToggleSelector.on('click', this.guestToggle.bind(this))
    this.elements.$roomCountToggleSelector.on(
      'click',
      this.roomCountToggle.bind(this)
    )
    this.elements.$checkOutDatepickerSelector.on(
      'click',
      this.checkOutClick.bind(this)
    )
    this.elements.$roomCountSelector.on(
      'change',
      this.roomCountChange.bind(this)
    )
    this.elements.$adultSelector.on('change', this.adultChange.bind(this))
    this.elements.$childrenSelector.on('change', this.childChange.bind(this))
    this.elements.$checkInDatepickerSelector.on(
      'change',
      this.checkInChange.bind(this)
    )
    this.elements.$checkOutDatepickerSelector.on(
      'change',
      this.checkOutChange.bind(this)
    )
    this.elements.$extrasSelector.on('change', this.extrasChange.bind(this))
    this.elements.$rateToggleSelector.on('click', this.rateToggle.bind(this))
    this.elements.$rateSelector.on('change', this.rateChange.bind(this))
    this.outsideClickToggle()
    this.initGuestHolder()
    this.initRoomCountHolder()
  }
  getBottomCenter = (el) => {
    const offset = el.offset()
    const height = el.outerHeight()
    const { top, left } = offset
    const topPos = top + height
    const leftPos = left

    return [topPos, leftPos]
  }
  initGuestHolder() {
    const adultCount = this.elements.$adultSelector.val() * 1
    const childrenCount = this.elements.$childrenSelector.val() * 1
    const roomCount = this.elements.$roomCountSelector.val() * 1

    let adultText, childrenText, roomCuntText

    if (adultCount === 1 || adultCount === 0) {
      adultText = i18n.i18n.adult
    } else {
      adultText = i18n.i18n.adults
    }

    if (childrenCount === 1 || childrenCount === 0) {
      childrenText = i18n.i18n.child
    } else {
      childrenText = i18n.i18n.children
    }

    if (
      this.elements.$formSelector.hasClass(
        'bhub-sp-template-booking-form--has-combined-fields'
      )
    ) {
      if (roomCount === 1 || roomCount === 0) {
        roomCuntText = i18n.i18n.room
      } else {
        roomCuntText = i18n.i18n.rooms
      }

      this.elements.$guestHolderSelector.html(
        `${roomCount} ${roomCuntText}, ${adultCount} ${adultText}, ${childrenCount} ${childrenText}`
      )
    } else {
      this.elements.$guestHolderSelector.html(
        `${adultCount} ${adultText}, ${childrenCount} ${childrenText}`
      )
    }
  }
  initRoomCountHolder() {
    const roomCount = this.elements.$roomCountSelector.val() * 1
    let roomCuntText

    if (roomCount === 1 || roomCount === 0) {
      roomCuntText = i18n.i18n.room
    } else {
      roomCuntText = i18n.i18n.rooms
    }

    this.elements.$roomCountHolderSelector.html(`${roomCount} ${roomCuntText}`)
  }
  adultChange() {
    this.initDynamicTotal()
    this.initGuestHolder()
  }
  childChange() {
    this.initDynamicTotal()
    this.initGuestHolder()
  }
  roomCountChange() {
    this.initDynamicTotal()
    if (
      this.elements.$formSelector.hasClass(
        'bhub-sp-template-booking-form--has-combined-fields'
      )
    ) {
      this.initGuestHolder()
    } else {
      this.initRoomCountHolder()
    }
  }
  checkInChange() {
    this.elements.$checkInDatepickerSelector.val(this.daterange[0])
    this.elements.$checkOutDatepickerSelector
      .val(this.daterange[1])
      .trigger('change')
  }
  checkOutChange() {
    this.initDynamicTotal()
  }
  checkOutClick() {
    this.elements.$checkInDatepickerSelector.focus()
  }
  extrasChange() {
    this.initDynamicTotal()
  }
  initDynamicTotal() {
    const that = this
    const form = this.elements.$formSelector
    const service = form.attr('data-service')
    const product = form.attr('data-product')
    const adult = this.elements.$adultSelector.val() * 1
    const children = this.elements.$childrenSelector.val() * 1
    const roomCount = this.elements.$roomCountSelector.val() * 1
    const rate = this.elements.$rateSelector.filter(':checked').val() || ''
    let extra = []
    this.elements.$extrasSelector.each(function () {
      if ($(this).is(':checked')) {
        extra.push($(this).val())
      }
    })

    if (that.daterange?.length !== 2 || !adult > 0) {
      return
    }

    $.ajax({
      url: i18n.ajaxUrl,
      method: 'POST',
      dataType: 'json',
      data: {
        _ajax_nonce: i18n.nonce,
        action: 'bhub/shortcode/dynamic_total',
        service,
        room_id: product,
        adult,
        children,
        extra,
        check_in: that.daterange[0],
        check_out: that.daterange[1],
        room_count: roomCount,
        rate,
      },
      beforeSend: () => {
        that.elements.$formSelector.bhubBlock()
      },
      success: function (response) {
        if (response.success) {
          that.elements.$buttonSelector.prop('disabled', false)
          that.elements.$totalHolderSelector.html(response.data.price_html)
        } else {
          if (response.data.criteria_error) {
            that.elements.$buttonSelector.prop('disabled', true)
          }
          alert(response.data.message)
        }
      },
      complete: () => {
        that.elements.$formSelector.bhubUnBlock()
      },
    })
  }
  outsideClickToggle() {
    const that = this
    $(document).on('click', function (e) {
      if (
        $(e.target).closest(that.elements.$roomCountFieldSelector).length === 0
      ) {
        that.elements.$formSelector.removeClass('bhub-room-count-active')
      }

      if ($(e.target).closest(that.elements.$guestFieldSelector).length === 0) {
        that.elements.$formSelector.removeClass('bhub-guest-active')
      }

      if ($(e.target).closest(that.elements.$rateFieldSelector).length === 0) {
        that.elements.$formSelector.removeClass('bhub-rate-active')
      }
    })
  }
  guestToggle() {
    this.elements.$formSelector.toggleClass('bhub-guest-active')
  }
  roomCountToggle() {
    this.elements.$formSelector.toggleClass('bhub-room-count-active')
  }
  rateToggle() {
    this.elements.$formSelector.toggleClass('bhub-rate-active')
  }
  rateChange() {
    const $checked = this.elements.$rateSelector.filter(':checked')
    if ($checked.length) {
      const title = $checked
        .closest('.bhub-rate-selection')
        .find('.bhub-rate-selection__title__text')
        .text()
        .trim()
      this.elements.$rateHolderSelector.text(title)

      $checked
        .closest('.bhub-rate-selection')
        .addClass('bhub-rate-selection-active')
        .siblings('.bhub-rate-selection')
        .removeClass('bhub-rate-selection-active')
    }
    this.elements.$formSelector.removeClass('bhub-rate-active')
    this.initDynamicTotal()
  }
  submitEvent(e) {
    e.preventDefault()

    const that = this
    const form = this.elements.$formSelector
    const service = form.attr('data-service')

    if (this.requesting) {
      return
    }

    if (!this.daterange.length) {
      alert(i18n.plsSelectADate)
      return
    }

    $.ajax({
      url: i18n.ajaxUrl,
      method: 'POST',
      dataType: 'json',
      data: [
        form.serialize(),
        $.param({
          action: 'bhub/shortcode/add_new_booking',
          service: service,
        }),
      ].join('&'),
      beforeSend: () => {
        that.elements.$formSelector.bhubBlock()
        that.requesting = true
      },
      success: function (response) {
        if (response.success) {
          if (response.data.redirect_message) {
            setTimeout(() => {
              window.location.href = response.data.redirect
            }, 3000)
            that.elements.$formSelector.after(
              `<div class="bhub-sp-template-booking-form__alert">${response.data.redirect_message}</div>`
            )
          } else {
            window.location.href = response.data.redirect
          }
        } else {
          alert(response.data.message)
        }
      },
      complete: () => {
        that.elements.$formSelector.bhubUnBlock()
        that.requesting = false
      },
    })
  }
  initInputSpinner() {
    this.elements.$inputSpinnerSelector.each((index, input) => {
      initInputSpinner(input)
    })
  }
  loadLottieSearchAnimation() {
    const el = this.elements.$lottieSearchAnimationSelector.get(0)
    const container = this.elements.$buttonSelector.get(0)

    const searchLottie = lottie.loadAnimation({
      container: el,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: `${i18n.assetsUrl}/lottie-animations/search.json`,
    })

    searchLottie.addEventListener('data_ready', () => {
      const totalFrames = searchLottie.totalFrames
      const halfFrame = totalFrames / 2

      container.addEventListener('mouseenter', () => {
        searchLottie.setSpeed(1.5)
        searchLottie.setDirection(1)
        searchLottie.playSegments([0, halfFrame], true)
      })

      container.addEventListener('mouseleave', () => {
        searchLottie.setSpeed(1.75)
        searchLottie.goToAndStop(halfFrame, true)
        searchLottie.playSegments([halfFrame, 0], true)
      })
    })
  }
  getDates(ymd = '') {
    const form = this.elements.$formSelector
    const service = form.attr('data-service')
    const product = form.attr('data-product')

    return new Promise((resolve, reject) => {
      $.ajax({
        url: i18n.ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'bhub/shortcode/get_dates',
          service,
          room_id: product,
          nonce: i18n.nonce,
          date: ymd,
        },
        success: function (response) {
          if (response.success) {
            const formattedDays = response.data.disabledDays.map((date) => {
              return new Date(date)
            })

            resolve(formattedDays)
          } else {
            reject(response.data.message)
          }
        },
      })
    })
  }
  initCalendar(el, disabledDays) {
    const that = this
    this.mainArgs = this.elements.$formSelector.data('args')
    const { minAllowedDays, maxAllowedDays } = this.mainArgs
    const position = this.elements.$formSelector.attr(
      'data-datepicker-position'
    )
    const classes = this.elements.$formSelector.attr('data-id')
    const language = this.elements.$formSelector.attr(
      'data-datepicker-language'
    )
    const rawLocale = airDatepickerLocales[language]
    const locale =
      language && language !== 'default' && rawLocale
        ? (rawLocale.default ?? rawLocale)
        : null

    return new BHubCalendar(el, {
      classes: `bhub-airdatepicker bhub-${classes}`,
      autoClose: true,
      range: true,
      ...(locale ? { locale } : {}),
      multipleDatesSeparator: ' - ',
      position: `${position} center`,
      nightCounter: true,
      rangeHasDisabledDayTooltipMsg: i18n.i18n.unavailableDay,
      rangeDisabledTooltipMaxLimitMsgSingular: i18n.i18n.maxNightSingular,
      rangeDisabledTooltipMaxLimitMsgPlural: i18n.i18n.maxNightPlural,
      rangeDisabledTooltipMinLimitMsgSingular: i18n.i18n.minNightSingular,
      rangeDisabledTooltipMinLimitMsgPlural: i18n.i18n.minNightPlural,
      nightCounterSingular: i18n.i18n.nightCounterSingular,
      nightCounterPlural: i18n.i18n.nightCounterPlural,
      maxRange: maxAllowedDays,
      minRange: minAllowedDays,
      onChangeViewDate: ({ month, year }) => {
        const ymd = that.getYmd(month, year)
        that.date = ymd
      },
      onRenderCell: ({ date, cellType, datepicker }) => {
        if ('day' !== cellType) return
        if (date.getMonth() !== datepicker.viewDate.getMonth()) return

        const isDisabled = disabledDays.some(
          (disabledDate) =>
            date.toLocaleDateString() === disabledDate.toLocaleDateString()
        )

        if (isDisabled) {
          return {
            disabled: true,
          }
        }
      },
      onSelect: ({ formattedDate, datepicker }) => {
        if (formattedDate.length === 1) {
          const $input = this.elements.$checkOutDatepickerSelector
          const $picker = $(datepicker.$datepicker)
          let top, left

          if (position === 'bottom') {
            top = $input.offset().top + $input.outerHeight() + 12 // 12px for calendar arrow
            left =
              $input.offset().left +
              $input.outerWidth() / 2 -
              $picker.outerWidth() / 2

            $picker.css({
              transition: '250ms',
              top: `${top}px`,
            })

            if (
              !that.elements.$formSelector.hasClass(
                'bhub-sp-template-booking-form--vertical'
              )
            ) {
              $picker.css({
                left: `${left}px`,
              })
            }
          }

          if (position === 'top') {
            top = $input.offset().top - $picker.outerHeight() - 12 // 12px for calendar arrow
            left =
              $input.offset().left +
              $input.outerWidth() / 2 -
              $picker.outerWidth() / 2

            $picker.css({
              transition: '250ms',
              top: `${top}px`,
            })

            if (
              !that.elements.$formSelector.hasClass(
                'bhub-sp-template-booking-form--vertical'
              )
            ) {
              $picker.css({
                left: `${left}px`,
              })
            }
          }
        }

        if (formattedDate.length > 1) {
          this.daterange = formattedDate
          $(el).trigger('change')
          $(document).trigger('bhubDaterangeSelect', {
            datePicker: datepicker,
            from: 'bookingForm',
          })
        }
      },
      onShow: (animationComplete) => {
        if (!animationComplete) {
          if (!that.isElementInViewport(that.datepicker.$datepicker).right) {
            const $row = that.elements.$formSelector.find(
              '.bhub-sp-template-booking-form__date-field'
            )
            const $picker = $(that.datepicker.$datepicker)
            const left =
              $row.offset().left + $row.outerWidth() - $picker.outerWidth()

            $picker.css({
              left: `${left}px`,
            })
          }
        }
      },
      onHide: (isFinished) => {
        if (!isFinished) {
          return
        }

        if (this.daterange.length > 1) {
          this.elements.$checkInDatepickerSelector.val(this.daterange[0])
          this.elements.$checkOutDatepickerSelector.val(this.daterange[1])
        }
      },
    })
  }
  isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect()
    const fitsLeft = rect.left >= 0 && rect.left <= $(window).width()
    const fitsTop = rect.top >= 0 && rect.top <= $(window).height()
    const fitsRight = rect.right >= 0 && rect.right <= $(window).width()
    const fitsBottom = rect.bottom >= 0 && rect.bottom <= $(window).height()

    return {
      top: fitsTop,
      left: fitsLeft,
      right: fitsRight,
      bottom: fitsBottom,
      all: fitsLeft && fitsTop && fitsRight && fitsBottom,
    }
  }
  loadCalendars() {
    const datepicker = this.initCalendar(
      this.elements.$checkInDatepickerSelector.get(0),
      []
    )
    this.datepicker = datepicker
    window.bhubRoomDatePicker = datepicker
  }
}

$(window).on('elementor/frontend/init', () => {
  const addHandler = ($element) => {
    // eslint-disable-next-line no-undef
    elementorFrontend.elementsHandler.addHandler(
      BhubElementorBookingFormHandler,
      {
        $element,
      }
    )
  }

  // eslint-disable-next-line no-undef
  elementorFrontend.hooks.addAction(
    'frontend/element_ready/bhub-sp-template-booking-form.default',
    addHandler
  )
})
